import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ForgotCompanyCredentials } from '@pages/login-recovery-options/models/forgot-company-credentials.interface';
import { ForgotPasswordCredentials } from '@pages/login-recovery-options/models/forgot-password-credentials.interface';
import { ForgotUsernameCredentials } from '@pages/login-recovery-options/models/forgot-username-credentials.interface';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoginRecoveryService {
  private readonly httpClient = inject(HttpClient);

  recoverCredentialsByCompanyName(credentials: ForgotCompanyCredentials): Observable<void> {
    const url = 'api/v1/recovery/organization-names';

    return this.httpClient.post<void>(environment.portalApiUrl + url, credentials);
  }

  recoverCredentialsByUsername(credentials: ForgotUsernameCredentials): Observable<void> {
    const url = 'api/v1/users/recover-username';

    return this.httpClient.post<void>(environment.portalApiUrl + url, credentials);
  }

  recoverCredentialsByPassword(credentials: ForgotPasswordCredentials): Observable<void> {
    const url = 'api/v2/user/password/reset-request';

    return this.httpClient.post<void>(environment.portalApiUrl + url, credentials);
  }
}
